export const keywordsKeys = (t) => [
    {
        key: 'keywords',
        label: t('search.overview.keywords_chart.keywords'),
        type: 'bar',
    },
    {
        key: 'newKeywords',
        label: t('search.overview.keywords_chart.newKeywords'),
        type: 'bar',
    },
];

export const urlsKeys = (t) => [
    {
        key: 'urls',
        label: t('search.overview.url_chart.urls'),
        type: 'bar',
    },
    {
        key: 'newURLs',
        label: t('search.overview.url_chart.newURLs'),
        type: 'bar',
    },
];
